"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ImageWrapper = exports.Image = exports.ContainerDiv = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n"])));

exports.Wrapper = Wrapper;

var ContainerDiv = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row !important;\n  flex-wrap: nowrap;\n  height: 100%;\n  align-items: center;\n  @media (min-width: 768px) {\n    padding: ", ";\n  }\n"])), function (props) {
  return "0\n      calc((100vw - (".concat(90 * props.lastImgAspectRatio, "vh -\n        ").concat(90 * props.lastImgAspectRatio, "px)) / 2)\n      0\n      calc((100vw - (").concat(90 * props.firstImgAspectRatio, "vh -\n        ").concat(90 * props.firstImgAspectRatio, "px)) / 2)");
});

exports.ContainerDiv = ContainerDiv;

var ImageWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0px 8px;\n  width: ", ";\n"])), function (props) {
  return "calc(".concat(90 * props.aspectRatio, "vh - ").concat(90 * props.aspectRatio, "px);");
});

exports.ImageWrapper = ImageWrapper;

var Image = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  height: calc(90vh - 90px);\n"])));

exports.Image = Image;